import { objectFromEntries } from './objectFromEntries';
export function createSchema(steps) {
  return objectFromEntries(steps.map(function (step) {
    return [step.code, step];
  }));
}